module.exports = __webpack_public_path__ + "static/media/capaPrincipal.557024a7.svg";